import { axios, Response } from '../index'

export type Body = {
  checklistId: string
  taskId: string
  title: string
  checklistItems: ChecklistItem[]
}

export type ChecklistItem = {
  checklistItemId: string
  title: string
  responsibleForTheDemandId: string
}

const createChecklist = (body: Body): Response<null> => {
  return axios.post('/v1/tasks/checklist', body)
}

export default createChecklist
